<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form role="form" @submit.stop.prevent="prevet">
      <div class="main-popup-anexo vx-row img flex justify-center">
        <div class="vx-col containerimg sm:w-1/2 w-1/2 mb-2 text-center mt-4">
          <center>
            <div v-if="extensaoArquivo == 'mp4' && urlArquivoServidor">
              <video
                class="video"
                controls
                muted
                loop
                :src="urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor"
              ></video>
            </div>

            <div v-if="extensaoArquivo == 'pdf'">
              <img
                src="../../../src/assets/images/elements/PDF_file_icon2.png"
                width="100%"
                style="max-width: 150px"
              />
              <p>
                {{
                  extensaoArquivo == 'pdf' && urlArquivoLocal
                    ? nomeArquivo
                    : urlArquivoServidor.split('/').pop()
                }}
              </p>
              <p></p>
            </div>

            <div
              v-if="
                extensaoArquivo == 'jpeg' ||
                extensaoArquivo == 'jpg' ||
                extensaoArquivo == 'png' ||
                extensaoArquivo == 'gif'
              "
            >
              <img
                :src="urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor"
                width="100%"
                style="max-width: 250px"
              />
            </div>

            <div class="vx-col containerimg w-full mb-2 mt-4">
              <vs-textarea
                v-if="nomeArquivo"
                class="mt-6"
                label="Observação"
                v-model="formCadastro.observacao"
                id="observacao"
              />
            </div>
          </center>
          <input
            id="fileUpload"
            type="file"
            accept="audio/*,video/*,image/*,.pdf"
            hidden
            v-on:change="selecionaArquivoUpload"
          />
          <vs-button
            color="warning"
            type="border"
            class="w-full text-center"
            @click="chooseFiles()"
          >
            Escolher um Arquivo
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="nomeArquivo" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ nomeArquivo }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row" v-if="novoAtendimento != true">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <vs-button
            color="success"
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="disableSubmitButton"
            >Anexar</vs-button
          >
          <div v-if="showProgressBar == true">
            <span>Carregando... por favor, aguarde.</span>
            <vs-progress
              :height="8"
              :percent="progressPercentage"
              color="primary"
              >primary</vs-progress
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import io from 'socket.io-client';
import locale from './../../locale';
import service from '../../services';
import functions from '../../utils/functions';

export default {
  props: ['dadosRelacionamento', 'buscarRelacionamentos', 'novoAtendimento'],
  data() {
    return {
      extensaoArquivo: null,
      progressPercentage: null,
      showProgressBar: false,
      tamanhoParcialArquivoAcumulado: null,
      tamanhoParcialArquivo: null,
      tamanhoTotalArquivoLocal: null,
      reqQuery: null,
      urlArquivoLocal: null,
      arquivoLocal: null,
      disableChooseButton: true,
      disableSubmitButton: true,
      aguardeCadastro: false,
      urlArquivoServidor: null,
      files: new FormData(),
      image: null,
      tipoArquivo: null,
      nomeArquivo: null,
      formCadastro: {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculo: null,
        url: null,
        uploadedBy: null,
        ip: null,
        observacao: null,
      },
      socket: null,
      dadosRelacionamentoSubmit: null,
    };
  },
  methods: {
    prevet() {
      return;
    },
    selecionaArquivoUpload(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      this.arquivoLocal = files;
      this.tamanhoTotalArquivoLocal = this.arquivoLocal[0].size;
      this.urlArquivoLocal = URL.createObjectURL(this.arquivoLocal[0]);

      if (this.arquivoLocal) this.disableSubmitButton = false;

      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.nomeArquivo = files[0].name;

      this.verificaExtensaoArquivo();
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    verificaExtensaoArquivo() {
      if (this.urlArquivoLocal) {
        const ext = this.nomeArquivo.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoArquivo = ext;
        return true;
      }

      if (this.urlArquivoServidor && !this.urlArquivoLocal) {
        const ext = this.urlArquivoServidor.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoArquivo = ext;
        return true;
      }
      return false;
    },
    callOnSubmit(data) {
      if (data != null) {
        this.dadosRelacionamentoSubmit = data;
        this.onSubmit();
      }
    },
    onSubmit(data = null) {
      this.formCadastro.isUpload = true;
      this.showProgressBar = true;
      this.disableSubmitButton = true;
      this.disableChooseButton = true;
      const _dadosRelacionamento =
        this.dadosRelacionamentoSubmit == null
          ? this.dadosRelacionamento
          : this.dadosRelacionamentoSubmit;

      service
        .upload(
          'upload-v2',
          'relacionamento-anexos/' +
            _dadosRelacionamento.idRelacionamento +
            `?room=${this.reqQuery}`,
          this.files,
        )
        .then((response) => {
          this.formCadastro.url = response.urlImage;
          this.formCadastro.idRelacionamento =
            _dadosRelacionamento.idRelacionamento;
          this.formCadastro.idAssociado = _dadosRelacionamento.idAssociado;
          this.formCadastro.idVeiculo = _dadosRelacionamento.idVeiculo;
          this.formCadastro.idVeiculos = _dadosRelacionamento.idVeiculos;
          this.formCadastro.uploadedBy = _dadosRelacionamento.idUsuario;
          this.urlArquivoServidor = response.urlImage;
          
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.showProgressBar = true;
              this.disableSubmitButton = true;

              service
                .post(
                  'Relacionamento',
                  'inserir-anexos-relacionamento',
                  this.formCadastro,
                )
                .then(() => {
                  this.showProgressBar = false;
                  this.disableSubmitButton = false;
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: 'Dados Atualizados com sucesso',
                    color: 'success',
                  });
                  this.$emit('uploaded', true);
                  this.buscarRelacionamentos();
                  this.formCadastro = {
                    idRelacionamento: null,
                    idAssociado: null,
                    idVeiculo: null,
                    url: null,
                    uploadedBy: null,
                    observacao: null,
                  };
                  this.nomeArquivo = null;
                  this.progressPercentage = null;
                  this.tamanhoParcialArquivo = null;
                  this.tamanhoParcialArquivoAcumulado = null;
                  this.urlArquivoLocal = null;
                  this.urlArquivoServidor = null;
                  this.extensaoArquivo = null;
                })
                .catch(() => {
                  this.aguardeCadastro = false;
                  this.showProgressBar = false;
                  this.disableSubmitButton = false;
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: 'Não foi possível atualizar os Dados',
                    color: 'danger',
                  });
                });
            }
          });

          this.$vs.loading.close();
        })
        .catch(function (e) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    onReset(evt) {
      evt.preventDefault();
      (this.disableChooseButton = true),
        (this.disableSubmitButton = true),
        (this.formCadastro = {
          idEmpresa: null,
          observacao: null,
        });
      this.urlArquivoServidor = null;
      this.urlArquivoLocal = null;
      this.extensaoArquivo = null;
      this.tipoArquivo = null;
      this.nomeArquivo = null;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    calculatePercentage(totalValue, actualValue) {
      const percentage = (100 * actualValue) / totalValue;
      this.progressPercentage = percentage;
      return parseInt(this.progressPercentage);
    },
    connectWebSocket() {
      this.socket = io(process.env.VUE_APP_SERVER_SOCKET);
      this.socket.on('message', (res) => {
        if (res.length) {
          this.tamanhoParcialArquivo = res.length;

          this.tamanhoParcialArquivoAcumulado =
            this.tamanhoParcialArquivoAcumulado + this.tamanhoParcialArquivo;

          this.progressPercentage = this.calculatePercentage(
            this.tamanhoTotalArquivoLocal,
            this.tamanhoParcialArquivoAcumulado,
          );
        }
      });
      this.socket.on('join_room_response', () => {
        const dateTime = Date.now();
        this.files.set(
          'query',
          `upload-relacionamento-${this.idRelacionamento}-room${dateTime}`,
        );
      });
      this.socket.on('connect_error', (err) => {
        console.error(err);
      });
      this.socket.on('connect', () => {
        const dateTime = Date.now();
        this.reqQuery = `upload-relacionamento-${this.idAtendimento}-room${dateTime}`;
        this.socket.emit('join_room', this.reqQuery);
      });
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  async mounted() {
    this.connectWebSocket();
    this.formCadastro.ip = await functions.getIP();
  },
  destroyed() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
};
</script>

<style>
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.video {
  max-height: 140px;
}

@media (max-width: 1100px) {
  .video {
    max-height: 100px !important;
  }
}

@media (max-width: 1395px) {
  .video {
    max-height: 90px !important;
  }
}

.img .icone {
  font-size: 50px;
  color: #333;
}
</style>
